import axios from "./axiosInstance";

const TripDetailsGalleryAPI = {
  getTripDetailsGallery: () => axios.get(`/gallery`),
};

export default TripDetailsGalleryAPI;